














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TooltipDecorator extends Vue {
    @Prop({ type: String }) readonly content!: string
}
